export const calculateLeft = (value: number, min: number, max: number) => {
  return (100 * (value - min)) / (max - min);
};

type TimelineItem = { reverse?: boolean; year: number };

export const addReverseToTimelineDataItems = <T extends TimelineItem>(timelineData: T[], minYear?: number) => {
  const output: T[] = [];

  for (let idx = 0; idx < timelineData.length; idx++) {
    const currentRawItem = timelineData[idx];
    const previousProcessedItem = idx === 0 ? undefined : output[idx - 1];
    const isCloseToPrevious = previousProcessedItem && currentRawItem.year <= previousProcessedItem?.year + 1;

    output.push({
      ...currentRawItem,
      reverse:
        currentRawItem.reverse !== undefined
          ? currentRawItem.reverse
          : !previousProcessedItem || previousProcessedItem.reverse || currentRawItem.year === minYear
          ? false
          : isCloseToPrevious
          ? true
          : false,
    });
  }

  return output;
};
